
type ZodRefineFunc<T> = (value: T) => boolean | Promise<boolean>;
type ZodRefineFuncReturn<T> = ReturnType<ZodRefineFunc<T>>;

// Taken from https://v3.zod.dev/?id=refine
type ZodRefineParams = {
	// override error message
	message?: string;

	// appended to error path
	path?: (string | number)[];

	// params object you can use to customize message
	// in error map
	params?: object;
};


const SCRIPT_TAGS_REG_EXP = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/i;
const DANGEROUS_CHARS_REG_EXP = /[<>]/g;

const STRING_INVALID_CHARACTERS = {
	en: 'Input contains invalid characters',
	nb: 'Inndata inneholder ugyldige tegn',
};

const SCRIPT_TAGS = {
	en: 'script tags',
	nb: 'script tagger',
};

function hasScriptTag(str: string): boolean {
	return SCRIPT_TAGS_REG_EXP.test(str);
}

function hasDangerousChar(str: string): boolean {
	return DANGEROUS_CHARS_REG_EXP.test(str);
}

function hasScriptTagOrDangerousChar(str: string): boolean {
	return hasScriptTag(str) || hasDangerousChar(str);
}

export function notScriptTagOrDangerousChar(str: string): ZodRefineFuncReturn<string> {
	return !(hasScriptTagOrDangerousChar(str));
}

export function localizedScriptTagOrDangerousCharError({
	locale = 'en',
	str,
}: {
	locale?: 'en'|'nb';
	str: string;
}): ZodRefineParams {
	if (hasScriptTag(str)) {
		return {
			message: `${STRING_INVALID_CHARACTERS[locale]}: ${SCRIPT_TAGS[locale]}`,
		};
	}

	const dangerousChars = str.match(DANGEROUS_CHARS_REG_EXP);
	if (dangerousChars) {
		const uniqueDangerousChars: string[] = [];
		for (let i = 0; i < dangerousChars.length; i++) {
			const char = dangerousChars[i];
			if (!uniqueDangerousChars.includes(char)) {
				uniqueDangerousChars.push(char);
			}
		} // for
		return {
			message: `${STRING_INVALID_CHARACTERS[locale]}: ${uniqueDangerousChars.join('')}`,
		};
	}

	return {};
}
